import { render } from "./RoundTripTrueWrapperComponent.vue?vue&type=template&id=a0b8d834&scoped=true&ts=true"
import script from "./RoundTripTrueWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./RoundTripTrueWrapperComponent.vue?vue&type=script&lang=ts"

import "./RoundTripTrueWrapperComponent.vue?vue&type=style&index=0&id=a0b8d834&scoped=true&lang=css"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b8d834"]])

export default __exports__